<template>
  <div>
    <div class="bg-blue-750 text-white grow px-print-0 p-7 rounded-lg">
      <div>
        <h5
          class="text-xl font-semibold"
        >
          <span
            :class="{ 'hidden md:block': shouldShowOnlyHighlightsMobile }"
            data-i18n="dailyProgram"
          >
            {{ $t('dailyProgram') }}
          </span>
          <span
            v-if="shouldShowOnlyHighlightsMobile"
            class="md:hidden"
            data-i18n="highlightsOnTrip"
          >
            {{ $t('highlightsOnTrip') }}
          </span>
        </h5>
        <div
          v-if="hasMultipleItineraries"
          class="mt-3 mb-4 font-secondary"
          data-i18n="multipleDayPrograms"
        >
          {{ $t('multipleDayPrograms') }}
        </div>
      </div>

      <div class="flex flex-col">
        <div
          v-for="(highlightDay, i) in itineraryDays"
          :key="i"
          class="text-white mb-4 font-secondary"
          :class="{ 'hidden md:block': shouldShowOnlyHighlightsMobile }"
          :data-translation="highlightDay?.title_translationkey"
        >
          <div :class="{ 'hidden md:inline': shouldShowOnlyHighlightsMobile }">
            <span
              class="font-semibold"
              data-i18n="tripHighlights.day"
            >
              {{ $t('tripHighlights.day') }} {{ highlightDay.day }}
            </span>
            {{ highlightDay.title }}
          </div>
        </div>
      </div>

      <div
        v-if="trip.highlights.length"
        :class="shouldShowOnlyHighlightsMobile ? 'md:pt-2.5' : 'pt-4'"
      >
        <div
          v-for="highlight in trip.highlights"
          :key="highlight.id"
          class="flex items-start font-secondary"
        >
          <i-star-full
            :font-controlled="false"
            filled
            class="w-3.5 min-w-3.5 mt-1 mr-2"
          />
          <div>
            {{ highlight.highlight }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  activeItinerary: {
    type: Object,
    required: true,
  },
})

const tripStore = useTripStore()
const { hasMultipleItineraries, trip } = storeToRefs(tripStore)

const itineraryDays = computed(() => props.activeItinerary?.itinerary
  .filter((itinerary) => itinerary.day !== 'x'))

// const highlightGroupedDays = computed(
//   () => itineraryDays.value.map((day, index) => ({
//     ...day,
//     highlights: trip.value.highlights.filter((highlight) => highlight.position === index),
//   }))
// )

const shouldShowOnlyHighlightsMobile = computed(() => itineraryDays.value.length > 8)
</script>
